<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h1 mat-dialog-title>{{ title }}</h1>
  <div mat-dialog-content>
    <mat-form-field class="full-width">
      <input placeholder="Client Name" matInput formControlName="client_name" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <input placeholder="Client NPI" matInput formControlName="client_npi" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <input placeholder="Client Stedi NPI" matInput formControlName="client_stedi_npi" maxlength="10" inputmode="numeric" required />
      <mat-error *ngIf="form.get('client_stedi_npi')?.hasError('required')">Client Stedi NPI is required</mat-error>
      <mat-error *ngIf="form.get('client_stedi_npi')?.hasError('pattern')">Client Stedi NPI must be numeric, up to 10 digits</mat-error>
    </mat-form-field>

    <mat-form-field class="full-width">
      <input placeholder="Admin Email" matInput formControlName="admin_email" />
    </mat-form-field>

    <mat-form-field class="rate-field">
      <input placeholder="CCM Rate" matInput formControlName="ccm_clinical_rate" />
    </mat-form-field>

    <mat-form-field class="rate-field">
      <input placeholder="RPM Data Rate" matInput formControlName="software_license_rate" />
    </mat-form-field>

    <mat-form-field class="rate-field-last">
      <input placeholder="RPM Clinical Rate Address" matInput formControlName="rpm_clinical_rate" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>EMR</mat-label>
      <mat-select formControlName="emr">
        <mat-option *ngFor="let emr of emrList$ | async" [value]="emr"> {{ emr.display_name }} </mat-option>
      </mat-select>
      <mat-error>Select an EMR</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="isAthenaSelected" class="full-width">
      <input placeholder="Practice ID" matInput formControlName="welby_practice_id" required />
    </mat-form-field>

    <mat-form-field *ngIf="isAthenaSelected" class="full-width">
      <input placeholder="Department ID" matInput formControlName="department_id" required />
    </mat-form-field>

    <mat-form-field *ngIf="isAthenaSelected" class="full-width">
      <input placeholder="Supervising Provider ID" matInput formControlName="supervising_provider_id" required />
    </mat-form-field>

    <mat-form-field class="full-width">
      <input placeholder="Specialty" matInput formControlName="specialty" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxFill fxLayoutGap="5px" fxLayoutAlign="end end">
    <button mat-button type="button" (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="form.invalid" type="submit">Save Client</button>
  </div>
</form>
